import { APP_TO_BUILD } from "./appsConfig";

import elecSadGuy from "./otherAppAssets/electrical/resultList/sad_guy.png";
import elecUnlockWithPro from "./otherAppAssets/electrical/unlockWithPro/unlock.png";
import elecSpecificPracticePotion from "./otherAppAssets/electrical/specificPractice/potion.png";
import elecSplashIcon from "./otherAppAssets/electrical/splashScreen/splash.png";

import usSadGuy from "./otherAppAssets/electrical_us/resultList/sad_guy.png";
import usUnlockWithPro from "./otherAppAssets/electrical_us/unlockWithPro/unlock.png";
import usSpecificPracticePotion from "./otherAppAssets/electrical_us/specificPractice/potion.png";
import usSpecificPracticeRobot from "./otherAppAssets/electrical_us/specificPractice/robot.png";
import usSplashIcon from "./otherAppAssets/electrical_us/splashScreen/splash.png";

import plSadGuy from "./otherAppAssets/plumbing/resultList/sad_guy.png";
import plUnlockWithPro from "./otherAppAssets/plumbing/unlockWithPro/unlock.png";
import plHappyPlumberBuy from "./otherAppAssets/plumbing/specificPractice/happy_plumber_buy.png";
import plSplashIcon from "./otherAppAssets/plumbing/splashScreen/splash.png";

import ibewSplashIcon from "./otherAppAssets/ibew_aptitude/splashScreen/splash.png";

const assets: Record<string, any> = {
  electrical: {
    global: {
      mainColor: "#5DB075",
      secondaryButtonTextColor: "#303230",
    },
    resultList: {
      sad_guy: elecSadGuy,
      result_list_top_text:
        "Passing score is 70% and required average answer time is 2m 24s",
    },
    unlockWithPro: {
      unlock: elecUnlockWithPro,
      purchaseName: "Red Seal All Access",
      targetedPracticeText:
        "Practice hundred of questions on the areas you need most such as calculations or motors",
      secondSectionHeader: "2,000+ Exam-Level Questions",
      secondSectionText:
        "Access our database of questions crafted by electricians & tailored to match your exam",
      inDepthText:
        "Step-by-step guides for tough questions, especially for multistep code & calculations problems",
    },
    specificPractice: {
      unlock: elecSpecificPracticePotion,
      unlockText:
        "Access over 2,500 questions, different practice modes & simulate Levels & Red Seal Exams",
      unlockTitle: "Pass with Red Seal All Access",
      unlockBackgroundColor: "#5DB075",
    },
    upgradeToAllAccess: {
      unlock: elecSpecificPracticePotion,
      unlockText:
        "Unlock an extra 1,000 questions, Red Seal Industrial content, and Level 1-4 exam simulations.",
      unlockTitle: "Upgrade to All Access",
      unlockBackgroundColor: "#5DB075",
    },
    splashScreen: {
      icon: elecSplashIcon,
    },
    buyPro: {
      title: "Be a Red Seal Pro",
      finalLine: "Simulate the Red Seal exam to see if you’re ready",
      congratsMessage: "Congrats on becoming a Red Seal All Access member!",
      congratsDetails:
        "Check out the different Level exam modes and simulate the Red Seal Exam for Construction or Industrial!",
    },
  },

  electrical_us: {
    global: {
      mainColor: "#5DB075",
      secondaryButtonTextColor: "#303230",
    },
    resultList: {
      sad_guy: usSadGuy,
      result_list_top_text:
        "Passing score is {pass_score_perc} and required average answer time is {required_avg_time}",
    },
    unlockWithPro: {
      unlock: usUnlockWithPro,
      purchaseName: "NEC Pro",
      targetedPracticeText:
        "Practice hundred of questions on the areas you need most such as calculations or motors",
      secondSectionHeader: "3,000+ Exam-Level Questions",
      secondSectionText:
        "Access our database of questions crafted by electricians & tailored to match your exam",
      inDepthText:
        "Step-by-step guides for tough questions, especially for multistep code & calculations problems",
    },
    specificPractice: {
      unlock: usSpecificPracticePotion,
      unlockText:
        "Access over 3,000 questions, different practice modes & simulate the NEC Exam",
      unlockTitle: "Pass the NEC with Pro",
      unlockBackgroundColor: "#5DB075",
    },
    upgradeToAllAccess: {
      unlock: usSpecificPracticeRobot,
      unlockText:
        "Get step-by-step personalized help on NEC questions & code calcs—only with Dakota AI",
      unlockTitle: "1 Month of AI Tutor Free",
      unlockBackgroundColor: "#5DB075",
    },
    splashScreen: {
      icon: usSplashIcon,
    },
    buyPro: {
      title: "Be an NEC Pro",
      finalLine: "Simulate the NEC exam to see if you’re ready",
      congratsMessage: "Congrats on becoming an NEC Pro with AI ⚡️",
      congratsDetails:
        "Check out the different practice exam modes, your AI tutor and simulate the NEC Exam!",
      congratsMessageOld: `Congrats on getting access to Dakota's AI tutor`,
      congratsDetailsOld:
        "Explore over 19 topics and get step-by-step help from your AI tutor on tough questions.",
    },
  },

  plumbing: {
    global: {
      mainColor: "#E06438",
      secondaryButtonTextColor: "#E06438",
    },
    resultList: {
      sad_guy: plSadGuy,
      result_list_top_text:
        "Passing score is 70% and required average answer time is 1m 55s",
    },
    unlockWithPro: {
      unlock: plUnlockWithPro,
      purchaseName: "Red Seal Pro",
      targetedPracticeText:
        "Practice hundred of questions on the areas you need most from fixtures to appliances to sewage",
      secondSectionHeader: "500+ Exam-Level Questions",
      secondSectionText:
        "Access our database of questions crafted by plumbers & tailored to match your exam",
      inDepthText:
        "Step-by-step guides for tough questions and references to National Plumbing Code",
    },
    specificPractice: {
      unlock: plHappyPlumberBuy,
      unlockText:
        "Access over 500+ questions, different practice modes & simulate the Red Seal Exam",
      unlockTitle: "Pass the Red Seal with Pro",
      unlockBackgroundColor: "#E06438",
    },
    splashScreen: {
      icon: plSplashIcon,
    },
    buyPro: {
      title: "Be a Red Seal Pro",
      finalLine: "Simulate the Red Seal exam to see if you're ready",
      congratsMessage: "Congrats on becoming a Red Seal Pro ⚡️",
      congratsDetails:
        "Check out the different practice exam modes and simulate the Red Seal Exam!",
    },
  },

  ibew_aptitude: {
    global: {
      mainColor: "#5DB075",
      secondaryButtonTextColor: "#303230",
    },
    resultList: {
      sad_guy: elecSadGuy,
      result_list_top_text:
        "Passing score is 70% and required average answer time is 2m 6s",
    },
    unlockWithPro: {
      unlock: elecUnlockWithPro,
      purchaseName: "IBEW Pro",
      targetedPracticeText:
        "Practice hundreds of questions on algebra, number series, and reading comprehension",
      secondSectionHeader: "500+ Aptitude Questions",
      secondSectionText:
        "Access our database of questions crafted to match the IBEW aptitude test",
      inDepthText:
        "Step-by-step guides for tough questions, especially for algebra and number series problems",
    },
    specificPractice: {
      unlock: elecSpecificPracticePotion,
      unlockText:
        "Access over 500 questions, different practice modes & simulate the IBEW Aptitude Test",
      unlockTitle: "Pass with IBEW Pro",
      unlockBackgroundColor: "#5DB075",
    },
    splashScreen: {
      icon: ibewSplashIcon,
    },
    buyPro: {
      title: "Be an IBEW Pro",
      finalLine: "Simulate the IBEW aptitude test to see if you're ready",
      congratsMessage: "Congrats on becoming an IBEW Pro!",
      congratsDetails:
        "Check out the different practice modes and simulate the IBEW Aptitude Test!",
    },
  },
};

const assetsForApp = assets[APP_TO_BUILD];
export default assetsForApp;
